import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setCartData, setEmailValidity } from "@/store/cart/cartSlice";
import { getCartDataApi } from "@/clientSideApi/cart";

const useCart = () => {
    const dispatch = useDispatch();
    const data = useSelector((state) => state.cart.data);

    const loaderID = useSelector((state) => state.cart.loaderID);
    const subTitleId1 = useSelector((state) => state.cart.subTitleId1);
    const subTitleId2 = useSelector((state) => state.cart.subTitleId2);

    useEffect(() => {
        const handleGetCartData = async () => {
            const apiResponse = await getCartDataApi();
            if (apiResponse) {
                dispatch(setCartData(apiResponse));
                dispatch(setEmailValidity(!apiResponse.user_email === false));
                document.querySelectorAll(".animated-path").forEach(node => {
                    node.classList.remove(...node.classList);
                    node.classList.add('animation-stopped');
                })
            }
        }
        
        handleGetCartData();
    }, [loaderID, subTitleId1, subTitleId2, dispatch]);

    useEffect(() => {
        const handleCartLoadingState = (cartData) => {
            if (cartData.cart_lines && cartData.cart_lines.length > 0) {
                document.getElementById(loaderID).style.display = "none";
            } else {
                document.getElementById(loaderID).style.display = "flex";
                document.getElementById(subTitleId1).style.display = "none";
                document.getElementById(subTitleId2).style.display = "block";
            }
        }

        if(data !== null) handleCartLoadingState(data);
    }, [ data ])

    return {
        data
    }
}

export default useCart